import { Box } from '@mui/material';
import { EditorialQuickFilterSelector } from 'components/SavedSearch/editorial/EditorialQuickFilterSelector';
import { AISearchToggleButton } from '../AISearch/AISearchToggleButton';

export type EditorialPostSearchContentProps = {
  onRequestFocusSearchInput?: () => void;
  aiSearchActive?: boolean;
  showAiSearchToggle?: boolean;
  setAiSearchActive?: React.Dispatch<React.SetStateAction<boolean>>;
  onAiSearchActivate?: () => void;
  onAiSearchDeactivate?: () => void;
};

export const EditorialPostSearchContent = ({
  onRequestFocusSearchInput,
  aiSearchActive = false,
  showAiSearchToggle = false,
  setAiSearchActive,
  onAiSearchActivate,
  onAiSearchDeactivate,
}: EditorialPostSearchContentProps) => {
  return (
    <Box
      id="editorial-post-search-content"
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
        flex: 1,
        minWidth: 0,
        flexWrap: 'nowrap',
        whiteSpace: 'nowrap',
      }}
    >
      <EditorialQuickFilterSelector />
      <AISearchToggleButton
        show={showAiSearchToggle}
        aiSearchActive={aiSearchActive}
        setAiSearchActive={setAiSearchActive ?? (() => undefined)}
        onAiSearchActivate={onAiSearchActivate ?? (() => undefined)}
        onAiSearchDeactivate={onAiSearchDeactivate ?? (() => undefined)}
        onToggleComplete={onRequestFocusSearchInput}
      />
    </Box>
  );
};
